<div>
    <p (click)="editDashBoard()">Edit Dashboard</p>
    <p (click)="addCloneDashBoard()">Clone Dashboard</p>
</div>


